import { render } from "./cart-timer.vue?vue&type=template&id=d7ef1e32"
import script from "./cart-timer.vue?vue&type=script&lang=js"
export * from "./cart-timer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__